import { useEffect, useRef, useState } from "react";
import { useLocalizationService } from "@/services";
import {
  LocalizationDataKeyType,
  LocalizationAvailableLangType,
  LocalizationDataType,
} from "@/schemas/index";
import { availableLangList, defaultLang } from "./localization-context";

export function useLocalization() {
  const api = useLocalizationService();
  const [localization, setLocalization] = useState<LocalizationDataType>();
  const [currentLang, setCurrentLang] =
    useState<LocalizationAvailableLangType>();

  const currentPromiseFetchInit = useRef<any>();
  const currentPromiseFetchUpdate = useRef<any>();

  const prepareCurrentLang = (lang: any) => {
    const currentLang = availableLangList.includes(lang) ? lang : defaultLang;

    return currentLang;
  };

  const fetchLocalizationInit = () => {
    if (!currentPromiseFetchInit.current) {
      currentPromiseFetchInit.current = api.fetchDefaultLang();
      currentPromiseFetchInit.current
        .then((lang: LocalizationAvailableLangType) => {
          if (!lang) {
            console.error("fetchCurrentLang must be return: currentLang");
          }

          const prepareLang = prepareCurrentLang(lang);

          setCurrentLang(prepareLang);

          return api.fetchData(prepareLang);
        })
        .then((data: LocalizationDataType) => {
          setLocalization(data);
        })
        .finally(() => {
          currentPromiseFetchInit.current = null;
        });
    }

    return currentPromiseFetchInit.current;
  };

  const fetchLocalizationUpdate = (lang: LocalizationAvailableLangType) => {
    if (!currentPromiseFetchUpdate.current) {
      currentPromiseFetchUpdate.current = Promise.resolve(
        prepareCurrentLang(lang),
      )
        .then((prepareLang: LocalizationAvailableLangType) => {
          setCurrentLang(prepareLang);
          return api.fetchData(prepareLang);
        })
        .then((data: LocalizationDataType) => {
          setLocalization(data);
          return true;
        })
        .finally(() => {
          currentPromiseFetchUpdate.current = null;
        });
    }

    return currentPromiseFetchUpdate.current;
  };

  const getLocalizationValue = (key: LocalizationDataKeyType) => {
    return localization?.[key];
  };

  useEffect(() => {
    currentLang
      ? localStorage.setItem("lang", currentLang)
      : localStorage.removeItem("lang");
  }, [currentLang]);

  useEffect(() => {
    fetchLocalizationInit().catch(console.error);
  }, []);

  return {
    getLocalizationValue,
    localization,
    currentLang,
    fetchLocalizationUpdate,
  };
}
